import { Field, FieldProps, useFormikContext } from 'formik'
import { Button, Heading, Hr, Icon, TextInput } from '@pandiafi/design-system'
import React from 'react'
import { useTranslation } from 'react-i18next'

import FormFieldWrapper from '../../../../components/FormField'
import {
  AddTenantInput,
  NewTenantType,
} from '../../../../../common/validations'

type AddSingleTenantProps = {
  index: number
}

export const AddSingleTenant: React.FC<AddSingleTenantProps> = ({ index }) => {
  const { values: formValues, setFieldValue } =
    useFormikContext<AddTenantInput>()
  const { t } = useTranslation(['contractModification'])

  const { firstName, lastName } = formValues.tenants[index]

  const handleRemoveTenant = () => {
    const newTenants = formValues.tenants.filter((_, i) => i !== index)
    setFieldValue('tenants', newTenants)
  }

  return (
    <>
      {index > 0 && <Hr />}

      <div className="flex justify-between items-center mt-8">
        <Heading size="m" element="h4" className="mt-4 phone:font-medium">
          {firstName} {lastName}
        </Heading>

        {formValues.tenants.length > 0 && index > 0 && (
          <Button
            type="button"
            variant="icon"
            className="p-2 -m-2"
            onClick={() => handleRemoveTenant()}
          >
            <Icon icon="close-window" />
          </Button>
        )}
      </div>

      <Field name={`tenants.${index}.socialSecurityNumber`}>
        {({
          field,
          meta,
        }: FieldProps<NewTenantType['socialSecurityNumber']>) => (
          <FormFieldWrapper
            name={field.name}
            label={t('contractModification:labels.socialSecurityNumber')}
            className="mt-8"
            meta={meta}
            required
          >
            <TextInput {...field} />
          </FormFieldWrapper>
        )}
      </Field>

      <Field name={`tenants.${index}.firstName`}>
        {({ field, meta }: FieldProps<NewTenantType['firstName']>) => (
          <FormFieldWrapper
            name={field.name}
            label={t('contractModification:labels.firstName')}
            className="mt-8"
            meta={meta}
            required
          >
            <TextInput {...field} />
          </FormFieldWrapper>
        )}
      </Field>

      <Field name={`tenants.${index}.lastName`}>
        {({ field, meta }: FieldProps<NewTenantType['lastName']>) => (
          <FormFieldWrapper
            name={field.name}
            label={t('contractModification:labels.lastName')}
            className="mt-8"
            meta={meta}
            required
          >
            <TextInput {...field} />
          </FormFieldWrapper>
        )}
      </Field>

      <Field name={`tenants.${index}.email`}>
        {({ field, meta }: FieldProps<NewTenantType['email']>) => (
          <FormFieldWrapper
            name={field.name}
            label={t('contractModification:labels.email')}
            className="mt-8"
            meta={meta}
          >
            <TextInput {...field} />
          </FormFieldWrapper>
        )}
      </Field>

      <Field name={`tenants.${index}.phoneNumber`}>
        {({ field, meta }: FieldProps<NewTenantType['phoneNumber']>) => (
          <FormFieldWrapper
            name={field.name}
            label={t('contractModification:labels.phoneNumber')}
            className="mt-8 mb-16"
            meta={meta}
          >
            <TextInput {...field} />
          </FormFieldWrapper>
        )}
      </Field>
    </>
  )
}
